"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_SUITABLE_TAG_GROUP_ROW_ID = void 0;
exports.NO_SUITABLE_TAG_GROUP_ROW_ID = 'no_suitable_tag';
//# sourceMappingURL=tag-group.js.map